<template>
  <v-checkbox
  v-model="model"
  :label="$t(label)"
  :readonly="readonly"
  :disabled="disabled"
  :dense="dense"
  hide-details
  :error="error">
  </v-checkbox>
</template>
<script>
export default {
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  data() {
    return {
      
    }
  }
}
</script>
<style>
</style>